/** @format */

export const PhoneLarge = ({color}) => {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1131_371)">
                <path
                    d="M6.43556 13.8489C8.99556 18.88 13.12 23.0044 18.1511 25.5644L22.0622 21.6533C22.56 21.1556 23.2533 21.0133 23.8756 21.2089C25.8667 21.8667 28 22.2222 30.2222 22.2222C30.6937 22.2222 31.1459 22.4095 31.4793 22.7429C31.8127 23.0763 32 23.5285 32 24V30.2222C32 30.6937 31.8127 31.1459 31.4793 31.4793C31.1459 31.8127 30.6937 32 30.2222 32C22.2068 32 14.5197 28.8159 8.85188 23.1481C3.18412 17.4803 0 9.79321 0 1.77778C0 1.30628 0.187301 0.854097 0.520699 0.520699C0.854097 0.187301 1.30628 0 1.77778 0H8C8.4715 0 8.92368 0.187301 9.25708 0.520699C9.59048 0.854097 9.77778 1.30628 9.77778 1.77778C9.77778 4 10.1333 6.13333 10.7911 8.12444C10.9867 8.74667 10.8444 9.44 10.3467 9.93778L6.43556 13.8489Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_1131_371">
                    <rect width="32" height="32" fill={color} />
                </clipPath>
            </defs>
        </svg>
    );
};
